const isNonEmptyText = (value: unknown): value is string =>
    typeof value === 'string' && value.trim().length > 0;

export const resolveMembershipName = (item: any): string => {
    const value = [
        item?.membershipName,
        item?.ticketName,
        item?.membership?.name,
        item?.membership?.membershipName,
        item?.membership?.ticketName,
        item?.membershipInfo?.membership?.name,
        item?.scheduleRecord?.membershipName,
        item?.name,
    ].find(isNonEmptyText);

    return value?.trim() ?? '';
};

export const formatSessionText = (item: any, emptyText = '-'): string => {
    if (item?.currentSession === null || item?.currentSession === undefined) return emptyText;
    if (item?.totalSession === null || item?.totalSession === undefined) return emptyText;
    return `${item.currentSession}/${item.totalSession}`;
};
